const WhatsApp = () => {
  return (
    <a
      href="https://wa.me/+447866366197"
      class="whatsapp_float"
      target="_blank"
      rel="noopener noreferrer"
    >
      <i class="fa fa-whatsapp whatsapp-icon"></i>
    </a>
  );
};

export default WhatsApp;
